import React, {useEffect, useState, createContext} from "react";
import Results from "./Results.js"
import "./css/index.css"
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-material.css";
import {Route, Routes} from "react-router-dom";
import DetailsPage from "./DetailsPage";
import {useNavigate} from "react-router-dom";
import {Button, TextInput, Image, PasswordInput, Flex, Card, Text, Space} from '@mantine/core';
import '@mantine/core/styles.css';
import {useForm} from "@mantine/form";
import footer from "./images/footer.png"
import classes from "./css/Login.module.css"
import { useSelector, useDispatch } from 'react-redux';
import { setCustomer, setLoading } from './redux/actions';
import '@mantine/dates/styles.css';
import {useTranslation} from "react-i18next";
import LanguageSelect from "./components/LanguageSelect";

export const LoginContext = createContext()

export default function Login() {
  const navigate = useNavigate()
  const[isLoggedIn, setIsLoggedIn] = useState(false)
  const[username, setUsername] = useState("")
  const[password, setPassword] = useState("")
  const[lastSerialNumber, setLastSerialNumber] = useState('')
  const[lastActivationDate, setLastActivationDate] = useState('')

  useEffect(() => {
    if(localStorage.getItem("loggedIn")){
      setIsLoggedIn(true)
    }else{
      setIsLoggedIn(false)
    }
  }, []);

  const dispatch = useDispatch();
  const isLoading = useSelector(state => state.loading.isLoading);

  const login = async (e) => {
    dispatch(setLoading(true))
    let auth = {
      "user_name": username,
      "password": password
    }
    let formBody = []
    for (let property in auth) {
      let encodedKey = encodeURIComponent(property);
      let encodedValue = encodeURIComponent(auth[property]);
      formBody.push(encodedKey + "=" + encodedValue);
    }
    formBody = formBody.join("&");
    fetch("/api/v2/Login", {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      body: formBody
    }).then(response => {
      if(response.status === 200){
        setIsInvalid(false)
      }else if(response.status === 401) {
        setIsInvalid(true)
        dispatch(setLoading(false))
        return
      }
      return response.json()
    }).then(res => {
      let customerObject = res
      if(res){
        localStorage.setItem("customers", JSON.stringify(customerObject))
        localStorage.setItem("currentCustomer", JSON.stringify(Object.keys(customerObject)[0]))
        dispatch(setCustomer(Object.keys(customerObject)[0]));
        localStorage.setItem("loggedIn", "true")
        setIsLoggedIn(true)
      }else{
        setIsInvalid(true)
        //console.log("error")
      }
      dispatch(setLoading(false))
    }).catch((error)=>{
      console.log(error)
      //alert("Network Error, please try again!")
      dispatch(setLoading(false))
    })
  }

  const goBack = () => {
    navigate("/")
  }

  const logout = () => {
    localStorage.clear()
    setIsLoggedIn(false)
    document.cookie = "BMI_RDH=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/";
    //logout API does not work
    // fetch("/api/v1/Logout", {
    //   method: 'GET',
    // }).then(response => console.log(response.status))
    navigate('/')
  }

  const formatToBeaconDate = (date) => {
    if (date) {
      date = new Date(date)
      var tz = new Date().toLocaleTimeString('en-us',{timeZoneName:'short'}).split(' ')[2];
      var time = date.toLocaleTimeString();
      if (time.length === 10) {
        time = time.substring(0, 4) + ' ' + time.substring(8, 10);
      }
      if (time.length === 11) {
        time = time.substring(0, 5) + ' ' + time.substring(9, 11);
      }
      var formattedDate = date.toLocaleDateString() + ' ' + time + ' ' + tz;
      return formattedDate;
    }
    return '-';
  }
  const[isInvalid, setIsInvalid] = useState(false)
  const form = useForm({
    initialValues: {
      username: '',
      password: ''
    }})

  const { t } = useTranslation();
  const fetchEndpoints = (customerUuid, setData, currentCustomer) => {
    dispatch(setLoading(true))
    if(!customerUuid){
      customerUuid = ""
    }
    fetch(`/api/v1/Activation/List?` + new URLSearchParams({customer_uuid: customerUuid}),{
      method:"GET",
      credentials: 'include',
    }).then(response => response.json())
        .then(result => {
          if(!result){
            setData([])
            dispatch(setLoading(false))
            return
          }
          const withCustomerAndDateFields = result.Activations.map((e)=>({...e, Customer: currentCustomer, FormattedActivationTime: formatToBeaconDate(e.ActivationTime), FormattedLastCommunicationTime: formatToBeaconDate(e.LastCommunicationTime)}))
          setData(withCustomerAndDateFields)
          setLastSerialNumber(result.serial_number)
          setLastActivationDate(result.activation_date)
          dispatch(setLoading(false))
        }).catch((error)=>{
      console.log(error)
      logout() //prevent invalid cookie problems
      dispatch(setLoading(false))
    })
  }

  return (
      <div className="login">
        {!isLoggedIn ? (
            <div className="bg" style={{minHeight: '100vh' }}>
              <div className="gradient">
              <Flex
                  direction="column">
                <Card radius="0" mt="xl"
                       className={classes.loginCard}
                       p="xl"
                       bg="var(--mantine-color-white)">
                  <div align={"center"}>
                    <h1>ORION® Status Checker</h1>
                    <Image src={require("./images/orionlogo.jpg")}
                           radius={"md"}
                           // h={200}
                           w="75%"
                           fit="contain"
                           alt="Beacon Logo"
                    />
                    <br/>
                    <form onSubmit={form.onSubmit(() => {login()
                    })}>
                      <TextInput
                          required
                          aria-label="username"
                          type="text"
                          size="lg"
                          style={{width: '100%'}}
                          name="username"
                          value={username}
                          placeholder={t("Email Address")}
                          onChange={(e) => setUsername(e.target.value)}
                          error={isInvalid}
                      ></TextInput>
                      <PasswordInput
                          required
                          aria-label="password"
                          type="password"
                          size="lg"
                          style={{width: '100%'}}
                          name="password"
                          value={password}
                          placeholder={t("Password")}
                          onChange={(e) => setPassword(e.target.value)}
                          error={isInvalid}
                      ></PasswordInput>
                      {isInvalid && <div style={{color: 'red'}}>❗{t("invalid-credentials-message")}</div>}
                      <br/>
                      <Button size="md" style={{width: '100%'}} type="submit" id="btn" name="btn" loading={isLoading}
                      >{t("Login")}</Button>
                      <Space h="lg"/>
                      <Flex justify="space-between" align="center"><Text size="xs">Badger Meter, Inc. © 2009-2026. All Rights Reserved.</Text><LanguageSelect/></Flex>
                    </form>
                  </div>
                </Card>
                <Image src={footer} className={classes.loginCard}></Image>
              </Flex>
              </div>
            </div>
        ):(
            <div>
              <LoginContext.Provider value={{ logout: logout, formatToBeaconDate: formatToBeaconDate, goBack: goBack, fetchEndpoints: fetchEndpoints,
                lastActivationDate: lastActivationDate, lastSerialNumber: lastSerialNumber, setLastActivationDate:setLastActivationDate, setLastSerialNumber:setLastSerialNumber}}>
                <Routes>
                  <Route path={'/'} element={<Results />} />
                  <Route path={'/'} element={<Results />} />
                  <Route path='/:endpointSN' element={<DetailsPage />} />
                </Routes>
                <br />
              </LoginContext.Provider>
            </div>
        )}
      </div>

  );
}